/* eslint-disable */
export default {
  to: 'Versenden an:',
  transferTo: 'Übertragen an',
  blindTransfer: 'Weiterleiten',
  warmTransfer: 'Zuerst fragen',
  enterNameOrNumber: 'Nummer eingeben',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
